/**
 * Form dropdown options for Prospect Desk forms
 * These options are used across CreateNewProspect and Prospect Details forms
 */

/**
 * Car manufacturer options
 */
export const carMakerOptions = [
  { label: 'Acura', value: 'acura' },
  { label: 'Aiways', value: 'aiways' },
  { label: 'Alfa Romeo', value: 'alfa-romeo' },
  { label: 'Aston Martin', value: 'aston-martin' },
  { label: 'Audi', value: 'audi' },
  { label: 'Bentley', value: 'bentley' },
  { label: 'BMW', value: 'bmw' },
  { label: 'BMW Alpina', value: 'bmw-alpina' },
  { label: 'Bugatti', value: 'bugatti' },
  { label: 'Buick', value: 'buick' },
  { label: 'BYD', value: 'byd' },
  { label: 'Cadillac', value: 'cadillac' },
  { label: 'Chevrolet', value: 'chevrolet' },
  { label: 'Chrysler', value: 'chrysler' },
  { label: 'Citroen', value: 'citroen' },
  { label: 'Cupra', value: 'cupra' },
  { label: 'Dacia', value: 'dacia' },
  { label: 'Daewoo', value: 'daewoo' },
  { label: 'Did not Collect', value: 'did-not-collect' },
  { label: 'Dodge', value: 'dodge' },
  { label: 'DS', value: 'ds' },
  { label: 'Ferrari', value: 'ferrari' },
  { label: 'Fiat', value: 'fiat' },
  { label: 'Fisker', value: 'fisker' },
  { label: 'Ford', value: 'ford' },
  { label: 'Genesis', value: 'genesis' },
  { label: 'GMC', value: 'gmc' },
  { label: 'Honda', value: 'honda' },
  { label: 'Hongqi', value: 'hongqi' },
  { label: 'Hyundai', value: 'hyundai' },
  { label: 'Infiniti', value: 'infiniti' },
  { label: 'Jaguar', value: 'jaguar' },
  { label: 'Jeep', value: 'jeep' },
  { label: 'Kia', value: 'kia' },
  { label: 'Koenigsegg', value: 'koenigsegg' },
  { label: 'KTM', value: 'ktm' },
  { label: 'Lamborghini', value: 'lamborghini' },
  { label: 'Lancia', value: 'lancia' },
  { label: 'Land Rover', value: 'land-rover' },
  { label: 'Lexus', value: 'lexus' },
  { label: 'Lincoln', value: 'lincoln' },
  { label: 'Lotus', value: 'lotus' },
  { label: 'Lucid', value: 'lucid' },
  { label: 'Lynk & Co', value: 'lynk-co' },
  { label: 'Maserati', value: 'maserati' },
  { label: 'Maybach', value: 'maybach' },
  { label: 'Mazda', value: 'mazda' },
  { label: 'McLaren', value: 'mclaren' },
  { label: 'Mercedes-Benz', value: 'mercedes-benz' },
  { label: 'MG', value: 'mg' },
  { label: 'Mini', value: 'mini' },
  { label: 'Mitsubishi', value: 'mitsubishi' },
  { label: 'Nio', value: 'nio' },
  { label: 'Nissan', value: 'nissan' },
  { label: 'Opel', value: 'opel' },
  { label: 'Other', value: 'other' },
  { label: 'Peugeot', value: 'peugeot' },
  { label: 'Polestar', value: 'polestar' },
  { label: 'Porsche', value: 'porsche' },
  { label: 'Ram', value: 'ram' },
  { label: 'Renault', value: 'renault' },
  { label: 'Rimac', value: 'rimac' },
  { label: 'Rivian', value: 'rivian' },
  { label: 'Rolls Royce', value: 'rolls-royce' },
  { label: 'Saab', value: 'saab' },
  { label: 'Seat', value: 'seat' },
  { label: 'Skoda', value: 'skoda' },
  { label: 'Smart', value: 'smart' },
  { label: 'Subaru', value: 'subaru' },
  { label: 'Suzuki', value: 'suzuki' },
  { label: 'Tesla', value: 'tesla' },
  { label: 'Toyota', value: 'toyota' },
  { label: 'VinFast', value: 'vinfast' },
  { label: 'Volkswagen', value: 'volkswagen' },
  { label: 'Volvo', value: 'volvo' },
  { label: 'Voyah', value: 'voyah' },
  { label: 'Xpeng', value: 'xpeng' },
  { label: 'Zeekr', value: 'zeekr' },
];

/**
 * Personal title options
 */
export const titleOptions = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Dr', value: 'Dr' },
];

/**
 * Lucid vehicle model options
 */
export const interestedModelOptions = [
  { label: 'Lucid Air Pure', value: 'lucid-air-pure' },
  { label: 'Lucid Air Touring', value: 'lucid-air-touring' },
  { label: 'Lucid Air Grand Touring', value: 'lucid-air-grand-touring' },
  { label: 'Lucid Gravity Grand Touring', value: 'lucid-gravity-grand-touring' },
  { label: 'Lucid Gravity Dream Edition', value: 'lucid-gravity-dream-edition' },
];

/**
 * Purchase type options
 */
export const purchaseTypeOptions = [
  { label: 'Private', value: 'Private' },
  { label: 'Business', value: 'Business' },
];

/**
 * Finance type options
 */
export const financeTypeOptions = [
  { label: 'Cash', value: 'cash' },
  { label: 'Lease', value: 'lease' },
  { label: 'Finance', value: 'finance' },
  { label: 'Credit Card', value: 'credit-card' },
  { label: 'ACH', value: 'ach' },
  { label: 'Cryptocurrency', value: 'cryptocurrency' },
  { label: 'Self-arranged Finance', value: 'self-arranged-finance' },
  { label: 'Self-arranged lease', value: 'self-arranged-lease' },
  { label: 'Undecided', value: 'undecided' },
  { label: 'Purchase', value: 'purchase' },
];

/**
 * Purchase timing options
 */
export const purchaseTimingOptions = [
  { label: '1-3 months', value: '1-3 months' },
  { label: '3-6 months', value: '3-6 months' },
  { label: '6-9 months', value: '6-9 months' },
  { label: '9-12 months', value: '9-12 months' },
  { label: '12+ months', value: '12+ months' },
  { label: '2+ months', value: '2+ months' },
  { label: 'Did not Collect', value: 'did-not-collect' },
];

/**
 * Preferred contact method options
 */
export const preferredContactMethodOptions = [
  { label: 'Email', value: 'email' },
  { label: 'Phone', value: 'phone' },
  { label: 'Text/SMS', value: 'sms' },
];

/**
 * Email consent options
 */
export const emailConsentOptions = [
  { label: 'Email Opt In', value: 'emailOptIn' },
  { label: 'Email Opt Out', value: 'emailOptOut' },
];

/**
 * Phone consent options
 */
export const phoneConsentOptions = [
  { label: 'Call Opt In', value: 'callOptIn' },
  { label: 'Call Opt Out', value: 'callOptOut' },
];

/**
 * Test drive time slot options
 */
export const testDriveTimeOptions = [
  { label: '9:00 - 9:30', value: '9:00-9:30' },
  { label: '9:30 - 10:00', value: '9:30-10:00' },
  { label: '10:00 - 10:30', value: '10:00-10:30' },
  { label: '10:30 - 11:00', value: '10:30-11:00' },
  { label: '11:00 - 11:30', value: '11:00-11:30' },
  { label: '11:30 - 12:00', value: '11:30-12:00' },
  { label: '12:00 - 12:30', value: '12:00-12:30' },
  { label: '12:30 - 1:00', value: '12:30-1:00' },
  { label: '1:00 - 1:30', value: '1:00-1:30' },
  { label: '1:30 - 2:00', value: '1:30-2:00' },
  { label: '2:00 - 2:30', value: '2:00-2:30' },
  { label: '2:30 - 3:00', value: '2:30-3:00' },
  { label: '3:00 - 3:30', value: '3:00-3:30' },
  { label: '3:30 - 4:00', value: '3:30-4:00' },
  { label: '4:00 - 4:30', value: '4:00-4:30' },
  { label: '4:30 - 5:00', value: '4:30-5:00' },
];

/**
 * Test drive status options
 */
export const statusOptions = [
  { label: 'Scheduled', value: 'scheduled' },
  { label: 'Completed', value: 'completed' },
];

/**
 * Closed status sub status options
 */
export const closedSubStatusOptions = [
  { label: 'Junk', value: 'junk' },
  { label: 'Not Interested', value: 'not_interested' },
  { label: 'Not Qualified', value: 'not_qualified' },
  { label: 'Not a Sales Inquiry', value: 'not_sales_inquiry' },
  { label: 'Unresponsive', value: 'unresponsive' },
];

/**
 * Primary reason options for "Junk" sub status
 */
export const junkPrimaryReasons = [{ label: 'Invalid Email', value: 'invalid_email' }];

/**
 * Primary reason options for "Not Interested" sub status
 */
export const notInterestedPrimaryReasons = [
  { label: 'Charging', value: 'charging' },
  { label: 'Confidence in Company', value: 'confidence_in_company' },
  { label: 'Customer Experience', value: 'customer_experience' },
  { label: 'Environmental', value: 'environmental' },
  { label: 'Financing', value: 'financing' },
  { label: 'Purchased a Different Vehicle', value: 'purchased_different_vehicle' },
  { label: 'Service Network', value: 'service_network' },
  { label: 'Timing', value: 'timing' },
  { label: 'Vehicle Features', value: 'vehicle_features' },
];

/**
 * Primary reason options for "Not Qualified" sub status
 */
export const notQualifiedPrimaryReasons = [
  { label: 'B2B', value: 'b2b' },
  { label: 'Charging', value: 'charging' },
  { label: 'Environmental', value: 'environmental' },
  { label: 'Financing', value: 'financing' },
  { label: 'Timing', value: 'timing' },
  { label: 'Trade-In', value: 'trade_in' },
  { label: 'Other', value: 'other' },
];

/**
 * Primary reason options for "Not a Sales Inquiry" sub status
 */
export const notSalesInquiryPrimaryReasons = [
  { label: 'Vendor', value: 'vendor' },
  { label: 'Applicant', value: 'applicant' },
  { label: 'Media', value: 'media' },
];

/**
 * Secondary reason options mapped by primary reason
 */
export const secondaryReasonsByPrimary: Record<string, Array<{ label: string; value: string }>> = {
  // Charging (shared by Not Interested and Not Qualified)
  charging: [
    { label: 'High Installation Cost for Home Charging', value: 'high_installation_cost' },
    { label: 'Charging', value: 'charging' },
    { label: 'At home charging availability', value: 'at_home_charging_availability' },
    { label: 'No Bi-directional charging', value: 'no_bi_directional_charging' },
    { label: 'Prefer NACS charging', value: 'prefer_nacs_charging' },
    {
      label: 'Unsatisfactory Charging Infrastructure',
      value: 'unsatisfactory_charging_infrastructure',
    },
  ],
  // Confidence in Company (Not Interested)
  confidence_in_company: [
    { label: 'Company Stock', value: 'company_stock' },
    { label: 'Performance', value: 'performance' },
    { label: 'Company viability', value: 'company_viability' },
    {
      label: 'Concerns with Long term product support',
      value: 'concerns_long_term_product_support',
    },
    { label: 'Product Quality Concerns', value: 'product_quality_concerns' },
  ],
  // Customer Experience (Not Interested)
  customer_experience: [
    { label: 'Negative Social Media', value: 'negative_social_media' },
    { label: 'Review/Post', value: 'review_post' },
    { label: 'Studio', value: 'studio' },
    { label: 'Poor Test Drive Experience', value: 'poor_test_drive_experience' },
    {
      label: 'Sales Specialist could not provide detailed information requested',
      value: 'sales_specialist_no_detailed_info',
    },
    { label: 'Sales Specialist Unresponsive', value: 'sales_specialist_unresponsive' },
    { label: 'Unable to get a Test Drive Appointment', value: 'unable_test_drive_appointment' },
  ],
  // Environmental (shared by Not Interested and Not Qualified)
  environmental: [
    { label: 'Lack of Tax relief', value: 'lack_of_tax_relief' },
    { label: 'Political uncertainty', value: 'political_uncertainty' },
  ],
  // Financing (shared by Not Interested and Not Qualified)
  financing: [
    { label: 'Business Financing not available', value: 'business_financing_not_available' },
    { label: 'Downpayment too High', value: 'downpayment_too_high' },
    {
      label: 'Lack of Sufficient docs for stipulations',
      value: 'lack_of_sufficient_docs_for_stipulations',
    },
    { label: 'Leasing not available', value: 'leasing_not_available' },
    { label: 'Not ready to engage', value: 'not_ready_to_engage' },
    { label: 'Payment Too High', value: 'payment_too_high' },
    { label: 'Proposed Rate offered is too high', value: 'proposed_rate_offered_is_too_high' },
    { label: 'Unsaleable purchase option', value: 'unsaleable_purchase_option' },
    { label: 'Unfavorable financing terms', value: 'unfavorable_financing_terms' },
  ],
  // Purchased a Different Vehicle (Not Interested)
  purchased_different_vehicle: [{ label: 'Other EV', value: 'other_ev' }],
  // Service Network (Not Interested)
  service_network: [
    { label: 'Limited Physical Locations', value: 'limited_physical_locations' },
    { label: 'Not Present in market', value: 'not_present_in_market' },
    { label: 'Out of Mobile Service Locations', value: 'out_of_mobile_service_locations' },
    { label: 'Warranty concerns', value: 'warranty_concerns' },
  ],
  // Timing (shared by Not Interested and Not Qualified)
  timing: [
    { label: 'Extending Current Lease', value: 'extending_current_lease' },
    { label: 'Need a vehicle sooner', value: 'need_vehicle_sooner' },
    { label: 'Remaining in Current Vehicle', value: 'remaining_in_current_vehicle' },
    { label: 'Not ready to engage', value: 'not_ready_to_engage' },
    { label: 'Trade-In not available', value: 'trade_in_not_available' },
  ],
  // Vehicle Features (Not Interested)
  vehicle_features: [
    { label: 'Autonomous Driving', value: 'autonomous_driving' },
    { label: 'Battery degradation', value: 'battery_degradation' },
    { label: 'Colour options', value: 'colour_options' },
    { label: 'Comfort/Accessibility', value: 'comfort_accessibility' },
    { label: 'Head-up display', value: 'head_up_display' },
    { label: 'Range', value: 'range' },
    { label: 'Safety', value: 'safety' },
    { label: 'Security Features', value: 'security_features' },
    { label: 'Suspension', value: 'suspension' },
    { label: 'Towing', value: 'towing' },
    { label: 'Utility & Storage', value: 'utility_storage' },
    { label: 'Software features', value: 'software_features' },
  ],
  // B2B (Not Qualified)
  b2b: [
    { label: 'Not available on Company', value: 'not_available_on_company' },
    { label: 'Rate not favorable', value: 'rate_not_favorable' },
  ],
  // Trade-In (Not Qualified)
  trade_in: [
    { label: 'Customer vehicle not eligible for trade-in', value: 'vehicle_not_eligible_trade_in' },
    { label: 'Negative Equity', value: 'negative_equity' },
    { label: 'Offer Too Low', value: 'offer_too_low' },
    { label: 'Trade-In not available', value: 'trade_in_not_available' },
  ],
  // Other (Not Qualified)
  other: [
    { label: 'Vehicle Features', value: 'vehicle_features' },
    { label: 'Confidence in Company', value: 'confidence_in_company' },
    { label: 'Customer Experience', value: 'customer_experience' },
    {
      label: 'Purchased a Different Ve Service Network',
      value: 'purchased_different_ve_service_network',
    },
  ],
};
